module.exports = __webpack_public_path__ + "img/04n.e2bf7c47.gif";